import useAuthStore from "../stores/useAuthStore";

const useAuthenticated = () => {
  const userAuth = useAuthStore(s => s.userAuth);
  const shouldChangePassword = useAuthStore(s => s.shouldChangePassword);

  return !!(userAuth?.jwt && !shouldChangePassword);
};

export default useAuthenticated;
